module.exports = __webpack_public_path__ + "images/brooklyn-e5fa77ae0b5e5711889111497884654e.jpg";